// Client-side memory of the last Team dashboard payloads, so a revisit
// paints the previous figures instantly (with an "updated Ns ago" stamp)
// instead of zeros while the fresh poll is in flight. sessionStorage:
// per-tab, gone when the browser closes — a stale figure is never
// mistaken for today's on a later day, and the BE snapshot refreshes it
// within one poll anyway.

const PREFIX = "dash:snapshot:v1:";

export const loadSnapshot = <T,>(kind: string, scopeKey: string): T | null => {
    try {
        const raw = window.sessionStorage.getItem(`${PREFIX}${kind}:${scopeKey}`);
        return raw ? (JSON.parse(raw) as T) : null;
    } catch {
        return null;
    }
};

export const saveSnapshot = (kind: string, scopeKey: string, value: unknown): void => {
    try {
        window.sessionStorage.setItem(`${PREFIX}${kind}:${scopeKey}`, JSON.stringify(value));
    } catch {
        /* quota / private mode — the live fetch still works */
    }
};

// Whole seconds (or minutes from 60 s) since `atIso`; null when unknown.
export const updatedAgo = (atIso: string | null | undefined, nowMs: number): { secs: number } | { mins: number } | null => {
    if (!atIso) return null;
    const ms = Date.parse(atIso);
    if (Number.isNaN(ms)) return null;
    const secs = Math.max(0, Math.round((nowMs - ms) / 1000));
    return secs < 60 ? { secs } : { mins: Math.floor(secs / 60) };
};
